import React, { useState } from "react";

const PopUp = ({ id, label, title, message, subMessage, showModal }) => {
  const [isModalOpen, setIsModalOpen] = useState(showModal);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };
  return (
    <div
      className={`modal ${isModalOpen ? "show" : ""}`}
      id={id}
      aria-labelledby={label}
      aria-hidden={!isModalOpen}
      style={isModalOpen ? { display: "block" } : { display: "none" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content admin-list">
          <div className="modal-header">
            <h5 className="modal-title text-danger" id={label}>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={closeModal}
              aria-label="Close"
            ></button>
          </div>
          <div className="w-100 modal-body d-flex flex-column justify-content-center align-items-center gap-2">
            <div className="w-100 d-flex justify-content-start align-items-center text-white fw-bold">❗ {message}</div>
            <div className="w-100 d-flex justify-content-start align-items-center text-white">
            {subMessage}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
